<template>
  <router-view />
</template>

<script>

</script>
